// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../../work/modules/node_modules/css-loader/dist/cjs.js??ref--8-oneOf-1-1!../../../../../../../../../../work/modules/node_modules/postcss-loader/dist/cjs.js??ref--8-oneOf-1-2!../../../../../../../../../../work/modules/node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-1-3!./index.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../../../../work/modules/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("54566b62", content, true, {"sourceMap":false});